import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["access", "eventWrapper", "eventSelect"]

  connect() {
    this.update()
  }

  update() {
    const allowed = ["read", "read_write"].includes(this.accessTarget.value)

    if (this.hasEventWrapperTarget) {
      this.eventWrapperTarget.classList.toggle("opacity-40", !allowed)
    }

    if (this.hasEventSelectTarget) {
      this.eventSelectTarget.disabled = !allowed
    }
  }
}
